export const ARTIST_NOTIFICATIONS = "ARTIST_NOTIFICATIONS";
